<script lang="ts">
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { _ } from 'svelte-i18n';

	let lastScrollTop: number = 0;
	let BtnBook: HTMLElement | null = null;
	let bottomNavbar: HTMLElement | null = null;
	let topNavbar: HTMLElement | null = null;
	// let showLogo = false;

	const book_url = "https://www.ihg.com/holidayinnresorts/hotels/us/en/find-hotels/select-roomrate?fromRedirect=true&qSrt=sBR&qIta=99502222&icdv=99502222&qSlH=DPSBB&qRms=1&qAdlt=1&qChld=0&qCiD=03&qCiMy=02025&qCoD=04&qCoMy=02025&qAAR=6CBARC&qRtP=6CBARC&setPMCookies=true&qSHBrC=HI&qDest=Jl%20Pratama,%20No%2086,%20Tanjung%20Benoa,%20Bali,%20ID&srb_u=1&qChAge=&qRmFltr=";

	const lang = $page.params.locale;
	const currentPath = $page.url.pathname.replace(`/${$page.params.locale}`, '');
	
	onMount(() => {
		bottomNavbar = document.querySelector('.bottom-navbar');
		topNavbar = document.querySelector('.top-navbar');
		BtnBook = document.querySelector('.btn-booknow');
		
		// setTimeout(() => {
        //     showLogo = true;
        // }, 6000);

		if (topNavbar && bottomNavbar) {
			const handleScroll = () => {
				const scrollTop: number = window.pageYOffset || document.documentElement.scrollTop;

				if (scrollTop > lastScrollTop) {
					bottomNavbar?.classList.add('d-none');
					bottomNavbar?.classList.remove('d-flex');
					topNavbar?.classList.add('scrolled');
				} else if (scrollTop === 0) {
					bottomNavbar?.classList.remove('d-none');
					bottomNavbar?.classList.add('d-flex');
					topNavbar?.classList.remove('scrolled');
				}

				lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
			};

			window.addEventListener('scroll', handleScroll);

			// Cleanup listener when component is destroyed
			return () => {
				window.removeEventListener('scroll', handleScroll);
			};
		}
	});
</script>

<header id="navbar" class="ff-lola-mr">
	<!-- desktop -->
	<div class="container-fluid p-0 navbar-desktop fixed-top d-none d-md-block">
		<div class="top-navbar py-2 px-5 d-flex align-items-center justify-content-between">
			<div class="">
				<a data-sveltekit-reload href="/{lang}">
					<img alt="Holiday Inn Resort Nusa Dua" src="/img/logo-white.webp" class=" logo" />
				</a>
			</div>
			<div>
				<a
					data-sveltekit-reload
					href="/{lang}"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('home')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/rooms"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('rooms')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/facilities"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('facilities')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/dining"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('dining')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/offers"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('offers')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/events"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('events')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/weddings"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('weddings')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/gallery"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('gallery')}</a
				>
				<a
					data-sveltekit-reload
					href="/{lang}/contact"
					class="custom-nav-link py-3 me-md-4 text-decoration-none text-white">{$_('contact_us')}</a
				>
			</div>
			<div class="btn-booknow d-flex align-items-center">
				<a
					data-sveltekit-reload
					href="{book_url}"
					target="_blank"
					class="btn btn-outline-light rounded-0 py-2 px-4 text-uppercase me-3">{$_('btn_book')}</a
				>
				<div class="dropdown select-language">
					<a
						class="text-decoration-none text-white dropdown-toggle"
						role="button"
						aria-label="button"
						data-bs-toggle="dropdown"
						aria-expanded="false"
					>
						{#if lang === 'en'}
							<img
								src="/img/united-states.svg"
								alt="Holiday Inn Resort Nusa Dua"
								class=""
								style="width:32px"
							/>
						{:else if lang === 'id'}
							<img
								src="/img/indonesia.svg"
								alt="Holiday Inn Resort Nusa Dua"
								class=""
								style="width:32px"
							/>
						{:else if lang === 'cn'}
							<img
								src="/img/china.svg"
								alt="Holiday Inn Resort Nusa Dua"
								class=""
								style="width:32px"
							/>
						{:else if lang === 'kr'}
							<img
								src="/img/korea.svg"
								alt="Holiday Inn Resort Nusa Dua"
								class=""
								style="width:32px"
							/>
						{:else if lang === 'ru'}
							<img
								src="/img/russia.svg"
								alt="Holiday Inn Resort Nusa Dua"
								class=""
								style="width:32px"
							/>
						{/if}
					</a>
					<ul class="dropdown-menu main-bg mt-3" style="min-width:unset">
						<li>
							<div class="dropdown-item">
								<p class="text-center text-white mb-2">{$_('select_language')}</p>
								<div class="d-flex align-items-center justify-content-center">
									<a
										data-sveltekit-reload
										href={`/en${currentPath}`}
										class="text-decoration-none me-2"
									>
										<p class="mb-1">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src="/img/united-states.svg"
												class=""
												style="width:32px"
											/>
										</p>
										<p class="mb-0 text-white text-center">EN</p>
									</a>
									<a
										data-sveltekit-reload
										href={`/id${currentPath}`}
										class="text-decoration-none me-2"
										><p class="mb-1">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src="/img/indonesia.svg"
												class=""
												style="width:32px"
											/>
										</p>
										<p class="mb-0 text-white text-center">ID</p></a
									>
									<a
										data-sveltekit-reload
										href={`/cn${currentPath}`}
										class="text-decoration-none me-2"
										><p class="mb-1">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src="/img/china.svg"
												class=""
												style="width:32px"
											/>
										</p>
										<p class="mb-0 text-white text-center">CN</p></a
									>
									<a
										data-sveltekit-reload
										href={`/kr${currentPath}`}
										class="text-decoration-none me-2"
										><p class="mb-1">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src="/img/korea.svg"
												class=""
												style="width:32px"
											/>
										</p>
										<p class="mb-0 text-white text-center">KR</p></a
									>
									<a
										data-sveltekit-reload
										href={`/ru${currentPath}`}
										class="text-decoration-none me-0"
										><p class="mb-1">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src="/img/russia.svg"
												class=""
												style="width:32px"
											/>
										</p>
										<p class="mb-0 text-white text-center">RU</p></a
									>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="bottom-navbar d-flex flex-column px-5">
			<hr class="border-light border-1 opacity-100 my-0" />
		</div>
	</div>

	<!-- mobile -->
	<div class="container-fluid p-0 navbar-mobile d-block d-md-none">
		<div class="container p-0 fixed-top">
			<div class="row g-0 top-navbar-mobile align-items-center">
				<div class="col-6">
					<!-- {#if showLogo} -->
						<a data-sveltekit-reload href="/{lang}">
							<img alt="Holiday Inn Resort Nusa Dua" src="/img/logo-white.webp" class=" logo" />
						</a>
					<!-- {/if} -->
				</div>
				<div class="col-6 text-end text-white">
					<a
						class="text-decoration-none text-white"
						data-bs-toggle="offcanvas"
						data-sveltekit-reload
						href="#tab-navbar-mobile"
						role="button"
						aria-controls="tab-navbar-mobile"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
						>
							<path d="M2 6H14" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" />
							<path d="M14 22H26" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" />
							<path d="M2 14H26" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" />
						</svg></a
					>
				</div>
			</div>
		</div>

		<div class="container-fluid p-3 fixed-bottom">
			<div class="container p-0 bottom-navbar-mobile rounded-4">
				<div class="row g-0 justify-content-between align-items-center ff-helvetica py-1">
					<a
						data-sveltekit-reload
						href="/{lang}"
						class="custom-link-mobile text-decoration-none col text-center d-flex flex-column align-items-center justify-content-center p-2 text-white"
					>
						<span class="icon-navbar"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									d="M20.5153 9.72843L13.0153 2.65218C13.0116 2.64898 13.0082 2.64554 13.005 2.64187C12.7289 2.39074 12.369 2.25159 11.9958 2.25159C11.6225 2.25159 11.2627 2.39074 10.9866 2.64187L10.9763 2.65218L3.48469 9.72843C3.33187 9.86895 3.20989 10.0397 3.12646 10.2298C3.04303 10.4199 2.99997 10.6252 3 10.8328V19.5C3 19.8978 3.15804 20.2793 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H9C9.39782 21 9.77936 20.842 10.0607 20.5607C10.342 20.2793 10.5 19.8978 10.5 19.5V15H13.5V19.5C13.5 19.8978 13.658 20.2793 13.9393 20.5607C14.2206 20.842 14.6022 21 15 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2793 21 19.8978 21 19.5V10.8328C21 10.6252 20.957 10.4199 20.8735 10.2298C20.7901 10.0397 20.6681 9.86895 20.5153 9.72843ZM19.5 19.5H15V15C15 14.6022 14.842 14.2206 14.5607 13.9393C14.2794 13.658 13.8978 13.5 13.5 13.5H10.5C10.1022 13.5 9.72064 13.658 9.43934 13.9393C9.15804 14.2206 9 14.6022 9 15V19.5H4.5V10.8328L4.51031 10.8234L12 3.74999L19.4906 10.8216L19.5009 10.8309L19.5 19.5Z"
									fill="#B2B2B2"
								/>
							</svg></span
						>
						<span class="text-navbar">{$_('home')}</span>
					</a>
					<a
						data-sveltekit-reload
						href="/{lang}/rooms"
						class="custom-link-mobile text-decoration-none col text-center d-flex flex-column align-items-center justify-content-center p-2 text-white"
					>
						<span class="icon-navbar"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									d="M19.5 6.75H2.25V4.5C2.25 4.30109 2.17098 4.11032 2.03033 3.96967C1.88968 3.82902 1.69891 3.75 1.5 3.75C1.30109 3.75 1.11032 3.82902 0.96967 3.96967C0.829018 4.11032 0.75 4.30109 0.75 4.5V19.5C0.75 19.6989 0.829018 19.8897 0.96967 20.0303C1.11032 20.171 1.30109 20.25 1.5 20.25C1.69891 20.25 1.88968 20.171 2.03033 20.0303C2.17098 19.8897 2.25 19.6989 2.25 19.5V16.5H21.75V19.5C21.75 19.6989 21.829 19.8897 21.9697 20.0303C22.1103 20.171 22.3011 20.25 22.5 20.25C22.6989 20.25 22.8897 20.171 23.0303 20.0303C23.171 19.8897 23.25 19.6989 23.25 19.5V10.5C23.25 9.50544 22.8549 8.55161 22.1516 7.84835C21.4484 7.14509 20.4946 6.75 19.5 6.75ZM2.25 8.25H9V15H2.25V8.25ZM10.5 15V8.25H19.5C20.0967 8.25 20.669 8.48705 21.091 8.90901C21.5129 9.33097 21.75 9.90326 21.75 10.5V15H10.5Z"
									fill="#B2B2B2"
								/>
							</svg></span
						>
						<span class="text-navbar">{$_('rooms')}</span>
					</a>
					<a
						data-sveltekit-reload
						href="{book_url}" target="_blank"
						class="custom-link-mobile text-decoration-none col text-center d-flex flex-column align-items-center justify-content-center p-2 text-white"
					>
						<span class="icon-navbar icon-navbar-center"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									d="M5.25012 7.125C5.25012 5.63316 5.84275 4.20242 6.89764 3.14752C7.95253 2.09263 9.38327 1.5 10.8751 1.5C12.367 1.5 13.7977 2.09263 14.8526 3.14752C15.9075 4.20242 16.5001 5.63316 16.5001 7.125C16.5001 7.32391 16.4211 7.51468 16.2804 7.65533C16.1398 7.79598 15.949 7.875 15.7501 7.875C15.5512 7.875 15.3604 7.79598 15.2198 7.65533C15.0791 7.51468 15.0001 7.32391 15.0001 7.125C15.0001 6.03098 14.5655 4.98177 13.7919 4.20818C13.0183 3.4346 11.9691 3 10.8751 3C9.7811 3 8.73189 3.4346 7.9583 4.20818C7.18471 4.98177 6.75012 6.03098 6.75012 7.125C6.75012 7.32391 6.6711 7.51468 6.53045 7.65533C6.38979 7.79598 6.19903 7.875 6.00012 7.875C5.8012 7.875 5.61044 7.79598 5.46979 7.65533C5.32913 7.51468 5.25012 7.32391 5.25012 7.125ZM18.3751 11.25C17.9376 11.2495 17.507 11.3588 17.1226 11.5678C17.0078 11.2124 16.8184 10.8856 16.5671 10.6092C16.3159 10.3329 16.0086 10.1133 15.6657 9.96517C15.3228 9.81707 14.9522 9.74384 14.5788 9.75039C14.2054 9.75693 13.8376 9.8431 13.5001 10.0031V7.125C13.5001 6.42881 13.2236 5.76113 12.7313 5.26884C12.239 4.77656 11.5713 4.5 10.8751 4.5C10.1789 4.5 9.51124 4.77656 9.01896 5.26884C8.52668 5.76113 8.25012 6.42881 8.25012 7.125V14.625L7.89199 14.0503C7.54178 13.4485 6.96684 13.0104 6.29364 12.8325C5.62044 12.6546 4.90414 12.7514 4.3023 13.1016C3.70047 13.4518 3.2624 14.0267 3.08448 14.6999C2.90655 15.3731 3.00334 16.0894 3.35355 16.6912L6.1023 21.3787C6.1484 21.47 6.21269 21.5509 6.29121 21.6165C6.36973 21.682 6.46082 21.7308 6.55889 21.7598C6.65696 21.7889 6.75992 21.7975 6.86147 21.7853C6.96301 21.7731 7.06097 21.7402 7.14934 21.6887C7.23772 21.6372 7.31462 21.5682 7.37534 21.4859C7.43605 21.4036 7.47929 21.3098 7.5024 21.2101C7.52551 21.1105 7.52799 21.0072 7.5097 20.9066C7.49142 20.806 7.45274 20.7101 7.39605 20.625L4.65012 15.9375C4.57302 15.8095 4.52222 15.6673 4.50067 15.5194C4.47912 15.3715 4.48726 15.2208 4.52461 15.0761C4.56197 14.9314 4.62778 14.7955 4.71822 14.6765C4.80865 14.5575 4.92189 14.4578 5.05132 14.383C5.18076 14.3083 5.32378 14.2601 5.47206 14.2412C5.62033 14.2224 5.77087 14.2333 5.91488 14.2732C6.0589 14.3132 6.1935 14.3815 6.31083 14.4741C6.42817 14.5667 6.52587 14.6817 6.59824 14.8125L6.61137 14.8341L8.36262 17.6466C8.4486 17.7853 8.5775 17.8922 8.72974 17.951C8.88199 18.0099 9.04928 18.0175 9.20622 17.9726C9.36316 17.9277 9.50118 17.8329 9.59934 17.7025C9.6975 17.5721 9.75044 17.4132 9.75012 17.25V7.125C9.75012 6.82663 9.86864 6.54048 10.0796 6.3295C10.2906 6.11853 10.5767 6 10.8751 6C11.1735 6 11.4596 6.11853 11.6706 6.3295C11.8816 6.54048 12.0001 6.82663 12.0001 7.125V13.5C12.0001 13.6989 12.0791 13.8897 12.2198 14.0303C12.3604 14.171 12.5512 14.25 12.7501 14.25C12.949 14.25 13.1398 14.171 13.2804 14.0303C13.4211 13.8897 13.5001 13.6989 13.5001 13.5V12.375C13.5001 12.0766 13.6186 11.7905 13.8296 11.5795C14.0406 11.3685 14.3267 11.25 14.6251 11.25C14.9235 11.25 15.2096 11.3685 15.4206 11.5795C15.6316 11.7905 15.7501 12.0766 15.7501 12.375V14.25C15.7501 14.4489 15.8291 14.6397 15.9698 14.7803C16.1104 14.921 16.3012 15 16.5001 15C16.699 15 16.8898 14.921 17.0304 14.7803C17.1711 14.6397 17.2501 14.4489 17.2501 14.25V13.875C17.2501 13.5766 17.3686 13.2905 17.5796 13.0795C17.7906 12.8685 18.0767 12.75 18.3751 12.75C18.6735 12.75 18.9596 12.8685 19.1706 13.0795C19.3816 13.2905 19.5001 13.5766 19.5001 13.875V17.25C19.5001 19.2759 18.8345 20.6531 18.8289 20.6644C18.74 20.8423 18.7255 21.0482 18.7884 21.2368C18.8513 21.4255 18.9866 21.5814 19.1645 21.6703C19.2685 21.7229 19.3835 21.7502 19.5001 21.75C19.6395 21.7501 19.7761 21.7114 19.8946 21.6382C20.0132 21.565 20.109 21.4602 20.1714 21.3356C20.2061 21.2672 21.0011 19.6481 21.0011 17.25V13.875C21.0011 13.5302 20.9331 13.1888 20.8011 12.8702C20.6692 12.5517 20.4757 12.2623 20.2319 12.0185C19.988 11.7747 19.6985 11.5814 19.3799 11.4495C19.0614 11.3177 18.7199 11.2499 18.3751 11.25Z"
									fill="#333333"
								/>
							</svg></span
						>
						<span class="text-navbar">{$_('btn_book')}</span>
					</a>
					<a
						data-sveltekit-reload
						href="/{lang}/offers"
						class="custom-link-mobile text-decoration-none col text-center d-flex flex-column align-items-center justify-content-center p-2 text-white"
					>
						<span class="icon-navbar"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									d="M20.25 6.75H16.9613C16.9978 6.71906 17.0353 6.68906 17.0709 6.65625C17.3557 6.40329 17.5851 6.0943 17.745 5.74861C17.9049 5.40292 17.9917 5.02796 18 4.64718C18.0123 4.23063 17.9394 3.81595 17.7856 3.42861C17.6319 3.04127 17.4006 2.68944 17.106 2.39471C16.8113 2.09999 16.4596 1.8686 16.0723 1.71474C15.685 1.56088 15.2703 1.48781 14.8538 1.5C14.4728 1.5082 14.0977 1.59495 13.7518 1.75482C13.406 1.91468 13.0968 2.14422 12.8438 2.42906C12.4936 2.8349 12.2089 3.29291 12 3.78656C11.7911 3.29291 11.5064 2.8349 11.1562 2.42906C10.9032 2.14422 10.594 1.91468 10.2482 1.75482C9.90232 1.59495 9.52718 1.5082 9.14625 1.5C8.72969 1.48781 8.31503 1.56088 7.92774 1.71474C7.54044 1.8686 7.18868 2.09999 6.89405 2.39471C6.59941 2.68944 6.36812 3.04127 6.21438 3.42861C6.06064 3.81595 5.98768 4.23063 6 4.64718C6.00833 5.02796 6.09514 5.40292 6.255 5.74861C6.41486 6.0943 6.64434 6.40329 6.92906 6.65625C6.96469 6.68718 7.00219 6.71718 7.03875 6.75H3.75C3.35218 6.75 2.97064 6.90803 2.68934 7.18934C2.40804 7.47064 2.25 7.85217 2.25 8.25V11.25C2.25 11.6478 2.40804 12.0294 2.68934 12.3107C2.97064 12.592 3.35218 12.75 3.75 12.75V18.75C3.75 19.1478 3.90804 19.5294 4.18934 19.8107C4.47064 20.092 4.85218 20.25 5.25 20.25H18.75C19.1478 20.25 19.5294 20.092 19.8107 19.8107C20.092 19.5294 20.25 19.1478 20.25 18.75V12.75C20.6478 12.75 21.0294 12.592 21.3107 12.3107C21.592 12.0294 21.75 11.6478 21.75 11.25V8.25C21.75 7.85217 21.592 7.47064 21.3107 7.18934C21.0294 6.90803 20.6478 6.75 20.25 6.75ZM13.9688 3.42281C14.0875 3.29167 14.2321 3.1865 14.3934 3.1139C14.5547 3.0413 14.7293 3.00284 14.9062 3.00093H14.9522C15.1595 3.00223 15.3645 3.0449 15.5552 3.12644C15.7458 3.20798 15.9183 3.32675 16.0624 3.47579C16.2066 3.62483 16.3195 3.80115 16.3947 3.99441C16.4698 4.18766 16.5056 4.39397 16.5 4.60125C16.4981 4.77815 16.4596 4.95275 16.387 5.11408C16.3144 5.27541 16.2093 5.42 16.0781 5.53875C15.1884 6.32625 13.7119 6.60375 12.7969 6.70125C12.9094 5.70843 13.2188 4.26562 13.9688 3.42281ZM7.96031 3.45656C8.25088 3.16602 8.64441 3.00194 9.05531 3H9.10125C9.27815 3.0019 9.45275 3.04037 9.61409 3.11297C9.77542 3.18556 9.92 3.29073 10.0388 3.42187C10.8253 4.31062 11.1028 5.78437 11.2003 6.69562C10.2891 6.60187 8.81531 6.32062 7.92656 5.53406C7.79543 5.41531 7.69026 5.27073 7.61766 5.1094C7.54506 4.94806 7.5066 4.77346 7.50469 4.59656C7.49887 4.38584 7.53593 4.17614 7.61361 3.98018C7.69128 3.78421 7.80796 3.60607 7.95656 3.45656H7.96031ZM3.75 8.25H11.25V11.25H3.75V8.25ZM5.25 12.75H11.25V18.75H5.25V12.75ZM18.75 18.75H12.75V12.75H18.75V18.75ZM20.25 11.25H12.75V8.25H20.25V11.25Z"
									fill="#B2B2B2"
								/>
							</svg></span
						>
						<span class="text-navbar">{$_('offers')}</span>
					</a>
					<a
						data-sveltekit-reload
						href="https://wa.me/6281139602069"
						target="_blank"
						class="custom-link-mobile text-decoration-none col text-center d-flex flex-column align-items-center justify-content-center p-2 text-white"
					>
						<span class="icon-navbar"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								fill="none"
								viewBox="0 0 256 256"
								><path
									d="M138,120a10,10,0,1,1-10-10A10,10,0,0,1,138,120ZM84,110a10,10,0,1,0,10,10A10,10,0,0,0,84,110Zm88,0a10,10,0,1,0,10,10A10,10,0,0,0,172,110Zm58-54V184a14,14,0,0,1-14,14H154.41L140.16,223a14,14,0,0,1-24.32,0L101.59,198H40a14,14,0,0,1-14-14V56A14,14,0,0,1,40,42H216A14,14,0,0,1,230,56Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V184a2,2,0,0,0,2,2h65.07a6,6,0,0,1,5.21,3l16,28a2,2,0,0,0,3.48,0l16-28a6,6,0,0,1,5.21-3H216a2,2,0,0,0,2-2Z" fill="#B2B2B2"
								></path></svg
							></span
						>
						<span class="text-navbar">{$_('chat')}</span>
					</a>
				</div>
			</div>
		</div>

		<div
			class="offcanvas offcanvas-top"
			tabindex="-1"
			id="tab-navbar-mobile"
			aria-labelledby="offcanvasExampleLabel"
		>
			<div class="offcanvas-header align-items-center px-4 pt-3 pb-2">
				<div class="d-flex align-items-center justify-content-between w-100">
					<a data-sveltekit-reload href="/{lang}/"
						><img alt="Holiday Inn Resort Nusa Dua" src="/img/logo.webp" class="logo" /></a
					>
					<div class="d-flex align-items-center">
						<div class="dropdown select-language me-2">
							<a
								class="text-decoration-none text-white dropdown-toggle"
								role="button"
								aria-label="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								{#if lang === 'en'}
									<img
										src="/img/united-states.svg"
										alt="Holiday Inn Resort Nusa Dua"
										class=""
										style="width:32px"
									/>
								{:else if lang === 'id'}
									<img
										src="/img/indonesia.svg"
										alt="Holiday Inn Resort Nusa Dua"
										class=""
										style="width:32px"
									/>
								{:else if lang === 'cn'}
									<img
										src="/img/china.svg"
										alt="Holiday Inn Resort Nusa Dua"
										class=""
										style="width:32px"
									/>
								{:else if lang === 'kr'}
									<img
										src="/img/korea.svg"
										alt="Holiday Inn Resort Nusa Dua"
										class=""
										style="width:32px"
									/>
								{:else if lang === 'ru'}
									<img
										src="/img/russia.svg"
										alt="Holiday Inn Resort Nusa Dua"
										class=""
										style="width:32px"
									/>
								{/if}
							</a>
							<ul class="dropdown-menu main-bg mt-3" style="min-width:unset">
								<li>
									<div class="dropdown-item">
										<p class="text-center text-white mb-2">{$_('select_language')}</p>
										<div class="d-flex align-items-center justify-content-center">
											<a
												data-sveltekit-reload
												href={`/en${currentPath}`}
												class="text-decoration-none me-3"
											>
												<p class="mb-1">
													<img
														alt="Holiday Inn Resort Nusa Dua"
														src="/img/united-states.svg"
														class=""
														style="width:32px"
													/>
												</p>
												<p class="mb-0 text-white text-center">EN</p>
											</a>
											<a
												data-sveltekit-reload
												href={`/id${currentPath}`}
												class="text-decoration-none me-3"
												><p class="mb-1">
													<img
														alt="Holiday Inn Resort Nusa Dua"
														src="/img/indonesia.svg"
														class=""
														style="width:32px"
													/>
												</p>
												<p class="mb-0 text-white text-center">ID</p></a
											>
											<a
												data-sveltekit-reload
												href={`/cn${currentPath}`}
												class="text-decoration-none me-3"
												><p class="mb-1">
													<img
														alt="Holiday Inn Resort Nusa Dua"
														src="/img/china.svg"
														class=""
														style="width:32px"
													/>
												</p>
												<p class="mb-0 text-white text-center">CN</p></a
											>
											<a
												data-sveltekit-reload
												href={`/kr${currentPath}`}
												class="text-decoration-none me-3"
												><p class="mb-1">
													<img
														alt="Holiday Inn Resort Nusa Dua"
														src="/img/korea.svg"
														class=""
														style="width:32px"
													/>
												</p>
												<p class="mb-0 text-white text-center">KR</p></a
											>
											<a
												data-sveltekit-reload
												href={`/ru${currentPath}`}
												class="text-decoration-none me-0"
												><p class="mb-1">
													<img
														alt="Holiday Inn Resort Nusa Dua"
														src="/img/russia.svg"
														class=""
														style="width:32px"
													/>
												</p>
												<p class="mb-0 text-white text-center">RU</p></a
											>
										</div>
									</div>
								</li>
							</ul>
						</div>
						<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"
						></button>
					</div>
				</div>
			</div>
			<div class="offcanvas-body">
				<div class="w-100 h-100 d-flex flex-column justify-content-between">
					<div
						class="ff-lola-bir fs-1 d-flex flex-column align-items-center justify-content-center pt-5"
					>
						<a data-sveltekit-reload href="/{lang}" class="text-decoration-none main-color mb-1"
							>{$_('home')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/rooms"
							class="text-decoration-none main-color mb-1">{$_('rooms')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/facilities"
							class="text-decoration-none main-color mb-1">{$_('facilities')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/dining"
							class="text-decoration-none main-color mb-1">{$_('dining')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/offers"
							class="text-decoration-none main-color mb-1">{$_('offers')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/events"
							class="text-decoration-none main-color mb-1">{$_('events')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/weddings"
							class="text-decoration-none main-color mb-1">{$_('weddings')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/gallery"
							class="text-decoration-none main-color mb-1">{$_('gallery')}</a
						>
						<a
							data-sveltekit-reload
							href="/{lang}/contact"
							class="text-decoration-none main-color mb-1">{$_('contact_us')}</a
						>
					</div>
					<div class="text-center mt-2">
						<small>
							<p class="ff-lola-bir main-color fs-5 mb-1">Holiday Inn Resort Bali Nusa Dua</p>
							<p class="mb-0 ff-helvetica">
								<a
									data-sveltekit-reload
									href="tel:03618947888"
									target="_blank"
									class="main-color text-decoration-none"
									><i class="ri-phone-line me-1 align-middle"></i><small
										>Reservation : +62 361 894 7888</small
									></a
								>
							</p>
							<p class="mb-0 ff-helvetica">
								<a
									data-sveltekit-reload
									href="mailto:reservation.nusadua@ihg.com"
									target="_blank"
									class="main-color text-decoration-none"
									><i class="ri-mail-line me-1 align-middle"></i><small
										>reservation.nusadua@ihg.com</small
									></a
								>
							</p>
							<p class="mb- ff-helvetica">
								<a
									data-sveltekit-reload
									href="https://maps.app.goo.gl/wwen7Rh1azvarTxy9"
									target="_blank"
									class="main-color text-decoration-none"
									><i class="ri-map-pin-line me-1 align-middle"></i><small
										>Jl. Pratama No.86, Tanjung, Benoa, Kec. Kuta Sel., Kabupaten Badung, Bali 80363</small
									></a
								>
							</p>
						</small>
						<p class="fs-4 mb-0">
							<a
								data-sveltekit-reload
								href="https://www.instagram.com/holidayinnbalinusadua/"
								target="_blank"
								class="main-color text-decoration-none"
								><svg
									xmlns="http://www.w3.org/2000/svg"
									width="30"
									height="30"
									viewBox="0 0 48 49"
									fill="none"
								>
									<path
										d="M24 15.6348C22.2941 15.6348 20.6266 16.1406 19.2082 17.0883C17.7898 18.0361 16.6843 19.3831 16.0315 20.9591C15.3787 22.5351 15.2079 24.2693 15.5407 25.9424C15.8735 27.6155 16.695 29.1523 17.9012 30.3586C19.1074 31.5648 20.6443 32.3862 22.3173 32.719C23.9904 33.0518 25.7246 32.881 27.3006 32.2282C28.8767 31.5754 30.2237 30.4699 31.1714 29.0516C32.1192 27.6332 32.625 25.9656 32.625 24.2598C32.622 21.9732 31.7124 19.7811 30.0955 18.1643C28.4787 16.5474 26.2866 15.6377 24 15.6348ZM24 30.6348C22.7391 30.6348 21.5066 30.2609 20.4582 29.5604C19.4099 28.8599 18.5928 27.8643 18.1103 26.6994C17.6278 25.5345 17.5015 24.2527 17.7475 23.0161C17.9935 21.7794 18.6006 20.6435 19.4922 19.752C20.3838 18.8604 21.5197 18.2532 22.7563 18.0073C23.9929 17.7613 25.2747 17.8875 26.4396 18.37C27.6045 18.8525 28.6001 19.6696 29.3006 20.718C30.0011 21.7664 30.375 22.9989 30.375 24.2598C30.375 25.9505 29.7034 27.572 28.5078 28.7676C27.3123 29.9631 25.6908 30.6348 24 30.6348ZM33 5.13477H15C12.3156 5.13774 9.74199 6.20544 7.84383 8.1036C5.94567 10.0018 4.87798 12.5754 4.875 15.2598V33.2598C4.87798 35.9442 5.94567 38.5178 7.84383 40.4159C9.74199 42.3141 12.3156 43.3818 15 43.3848H33C35.6844 43.3818 38.258 42.3141 40.1562 40.4159C42.0543 38.5178 43.122 35.9442 43.125 33.2598V15.2598C43.122 12.5754 42.0543 10.0018 40.1562 8.1036C38.258 6.20544 35.6844 5.13774 33 5.13477ZM40.875 33.2598C40.875 35.3483 40.0453 37.3514 38.5685 38.8282C37.0916 40.3051 35.0886 41.1348 33 41.1348H15C12.9114 41.1348 10.9084 40.3051 9.43153 38.8282C7.95468 37.3514 7.125 35.3483 7.125 33.2598V15.2598C7.125 13.1712 7.95468 11.1681 9.43153 9.6913C10.9084 8.21445 12.9114 7.38477 15 7.38477H33C35.0886 7.38477 37.0916 8.21445 38.5685 9.6913C40.0453 11.1681 40.875 13.1712 40.875 15.2598V33.2598ZM35.625 14.5098C35.625 14.8806 35.515 15.2431 35.309 15.5515C35.103 15.8598 34.8101 16.1001 34.4675 16.242C34.1249 16.384 33.7479 16.4211 33.3842 16.3487C33.0205 16.2764 32.6864 16.0978 32.4242 15.8356C32.1619 15.5734 31.9834 15.2393 31.911 14.8756C31.8387 14.5118 31.8758 14.1348 32.0177 13.7922C32.1596 13.4496 32.4 13.1568 32.7083 12.9508C33.0166 12.7447 33.3792 12.6348 33.75 12.6348C34.2473 12.6348 34.7242 12.8323 35.0758 13.1839C35.4275 13.5356 35.625 14.0125 35.625 14.5098Z"
										fill="#451C70"
									/>
								</svg></a
							>
							<a
								data-sveltekit-reload
								href="https://www.facebook.com/holidayinnbali"
								target="_blank"
								class="main-color text-decoration-none"
								><svg
									xmlns="http://www.w3.org/2000/svg"
									width="30"
									height="30"
									viewBox="0 0 48 49"
									fill="none"
								>
									<path
										d="M24 5.13477C20.2174 5.13477 16.5198 6.25643 13.3747 8.35791C10.2296 10.4594 7.77834 13.4463 6.33081 16.9409C4.88329 20.4356 4.50455 24.281 5.24249 27.9909C5.98043 31.7008 7.80191 35.1085 10.4766 37.7832C13.1513 40.4579 16.559 42.2793 20.2689 43.0173C23.9788 43.7552 27.8242 43.3765 31.3188 41.929C34.8135 40.4814 37.8004 38.0301 39.9019 34.885C42.0033 31.74 43.125 28.0423 43.125 24.2598C43.1191 19.1893 41.1022 14.3283 37.5168 10.7429C33.9315 7.15758 29.0704 5.14072 24 5.13477ZM25.125 41.0973V28.3848H30C30.2984 28.3848 30.5845 28.2662 30.7955 28.0553C31.0065 27.8443 31.125 27.5581 31.125 27.2598C31.125 26.9614 31.0065 26.6752 30.7955 26.4643C30.5845 26.2533 30.2984 26.1348 30 26.1348H25.125V21.2598C25.125 20.3647 25.4806 19.5062 26.1135 18.8733C26.7465 18.2403 27.6049 17.8848 28.5 17.8848H31.5C31.7984 17.8848 32.0845 17.7662 32.2955 17.5553C32.5065 17.3443 32.625 17.0581 32.625 16.7598C32.625 16.4614 32.5065 16.1752 32.2955 15.9643C32.0845 15.7533 31.7984 15.6348 31.5 15.6348H28.5C27.0082 15.6348 25.5774 16.2274 24.5225 17.2823C23.4676 18.3372 22.875 19.7679 22.875 21.2598V26.1348H18C17.7016 26.1348 17.4155 26.2533 17.2045 26.4643C16.9935 26.6752 16.875 26.9614 16.875 27.2598C16.875 27.5581 16.9935 27.8443 17.2045 28.0553C17.4155 28.2662 17.7016 28.3848 18 28.3848H22.875V41.0973C18.5067 40.8054 14.4228 38.8272 11.4857 35.5805C8.54865 32.3338 6.98838 28.0726 7.1344 23.697C7.28041 19.3214 9.12128 15.1737 12.2683 12.13C15.4152 9.08632 19.6219 7.38481 24 7.38481C28.3781 7.38481 32.5848 9.08632 35.7318 12.13C38.8787 15.1737 40.7196 19.3214 40.8656 23.697C41.0116 28.0726 39.4514 32.3338 36.5143 35.5805C33.5773 38.8272 29.4933 40.8054 25.125 41.0973Z"
										fill="#451C70"
									/>
								</svg></a
							>
							<a
								data-sveltekit-reload
								href="https://www.youtube.com/channel/UCAID2tIZzpFiHfNujh4TSww"
								target="_blank"
								class="main-color text-decoration-none"
								><svg
									xmlns="http://www.w3.org/2000/svg"
									width="30"
									height="30"
									viewBox="0 0 48 49"
									fill="none"
								>
									<path
										d="M30.6244 23.3223L21.6244 17.3223C21.4548 17.2092 21.2578 17.1443 21.0542 17.1344C20.8506 17.1246 20.6482 17.1703 20.4686 17.2665C20.289 17.3628 20.1389 17.5061 20.0343 17.681C19.9298 17.8559 19.8747 18.056 19.875 18.2598V30.2598C19.8747 30.4636 19.9298 30.6637 20.0343 30.8386C20.1389 31.0135 20.289 31.1568 20.4686 31.2531C20.6482 31.3493 20.8506 31.395 21.0542 31.3852C21.2578 31.3753 21.4548 31.3104 21.6244 31.1973L30.6244 25.1973C30.7791 25.0947 30.906 24.9554 30.9938 24.7918C31.0816 24.6282 31.1275 24.4455 31.1275 24.2598C31.1275 24.0742 31.0816 23.8914 30.9938 23.7278C30.906 23.5642 30.7791 23.4249 30.6244 23.3223ZM22.125 28.1579V20.3617L27.9712 24.2598L22.125 28.1579ZM43.575 13.3848C43.4122 12.7524 43.1016 12.1676 42.6687 11.6787C42.2358 11.1897 41.693 10.8105 41.085 10.5723C34.6875 8.09543 24.4256 8.1348 24 8.1348C23.5744 8.1348 13.3125 8.09543 6.9075 10.5723C6.30086 10.8115 5.75957 11.1911 5.32803 11.68C4.8965 12.1689 4.58703 12.7532 4.425 13.3848C3.94688 15.2392 3.375 18.6348 3.375 24.2598C3.375 29.8848 3.94688 33.2804 4.425 35.1348C4.58778 35.7672 4.89839 36.352 5.33128 36.8409C5.76417 37.3299 6.30696 37.7091 6.915 37.9473C13.3125 40.4242 23.5725 40.3848 24 40.3848H24.1331C25.4288 40.3848 35.0081 40.3023 41.0925 37.9473C41.7005 37.7091 42.2433 37.3299 42.6762 36.8409C43.1091 36.352 43.4197 35.7672 43.5825 35.1348C44.0606 33.2842 44.6325 29.8979 44.6325 24.2598C44.6325 18.6217 44.0625 15.2392 43.575 13.3848ZM41.3962 34.5723C41.324 34.8605 41.1844 35.1274 40.9888 35.351C40.7932 35.5747 40.5473 35.7486 40.2712 35.8586C34.2712 38.1704 24.1087 38.1348 24 38.1348C23.8913 38.1348 13.7419 38.1723 7.73438 35.8529C7.45836 35.743 7.21242 35.569 7.01683 35.3454C6.82123 35.1218 6.68158 34.8549 6.60938 34.5667C6.1575 32.8436 5.625 29.6561 5.625 24.2598C5.625 18.8636 6.1575 15.6761 6.60375 13.9473C6.67595 13.6591 6.81561 13.3922 7.0112 13.1686C7.2068 12.9449 7.45274 12.771 7.72875 12.6611C13.5113 10.4336 23.1619 10.3848 23.955 10.3848H24C24.1012 10.3848 34.2581 10.3473 40.2656 12.6667C40.5416 12.7766 40.7876 12.9506 40.9832 13.1742C41.1788 13.3978 41.3184 13.6647 41.3906 13.9529C41.8369 15.6761 42.3694 18.8636 42.3694 24.2654C42.3694 29.6673 41.8425 32.8436 41.3962 34.5723Z"
										fill="#451C70"
									/>
								</svg></a
							>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<style>
	#navbar .navbar-desktop {
		background: rgba(0, 0, 0, 0);
		transition: 0.3s all;
	}
	#navbar .navbar-desktop .logo {
		width: 80px;
	}

	/*mobile css*/
	#navbar .navbar-mobile .top-navbar-mobile {
		padding: 15px 20px 15px 20px;
		background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
	}
	#navbar .navbar-mobile .top-navbar-mobile .logo {
		width: 55px;
	}
	#navbar .navbar-mobile .offcanvas {
		height: 100%;
		width: 100%;
		/* background-image: url("{{ 'assets/img/bg-rooms.png'|theme  }}"); */
		background-size: cover;
		background-position: center;
	}
	#navbar .navbar-mobile .offcanvas-body {
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 0.8),
				rgba(255, 255, 255, 0.8),
				rgba(255, 255, 255, 1)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	#navbar .navbar-mobile .offcanvas .logo {
		width: 90px;
	}
	#navbar .navbar-mobile .bottom-navbar-mobile {
		background-color: rgba(0, 0, 0, 0.5);
		backdrop-filter: blur(10px);
	}
	#navbar .navbar-mobile .bottom-navbar-mobile .icon-navbar {
		font-size: 22px;
	}
	#navbar .navbar-mobile .bottom-navbar-mobile .text-navbar {
		margin-top: 3px;
		font-size: 12px;
	}
	#navbar .navbar-mobile .bottom-navbar-mobile .icon-navbar-center {
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: black;
		background-color: white;
		border-radius: 100%;
	}
	.select-language .dropdown-item:hover {
		background-color: unset !important;
	}
</style>
